import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const useGaTracker = () => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
      ReactGA.initialize("G-MX6GYDK28N");
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;
        t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "nwyka783k3");
  }, []);

  // useEffect(() => {
  //     if (initialized) {
  //     ReactGA.pageview(location.pathname);
  //     }
  // }, [initialized, location]);
};

export default useGaTracker;



// WEBPACK FOOTER //
// ./src/useGaTracker.js